import { retry } from '@lifeomic/attempt';

const defaultRetryOptions = {
  maxAttempts: 3,
};

class Utils {
  static capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  static sleep(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }
  static withRetry(anonFunction, options=defaultRetryOptions) {
    return retry(anonFunction, options);
  }
  static getScreenSize() {
    // See: https://stackoverflow.com/questions/1248081/how-to-get-the-browser-viewport-dimensions
    if (
        typeof document === 'undefined'
        || window === 'undefined'
    ) {
      return {
        height: null,
        width: null,
      };
    }
    const width = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const height = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return {
      height,
      width,
    };
  }
}

export default Utils;
